/* GENERATED FILE - DO NOT EDIT! */
define(['underscore'], function(_) {
  return function(context) {
    var __t, __p = '',
      __j = Array.prototype.join,
      print = function() {
        __p += __j.call(arguments, '');
      };
    __p += '<div is="slide-control" class="image-gallery__slide-control ' +
      ((__t = (context.className)) == null ? '' : __t) +
      '"><div class="slide-control ';
    if (context.offsetDisplay === true) {
      __p += 'slide-control--offset';
    }
    __p += '"><div class="slide-control__slides" data-slide-strip>';
    _.times(context.totalDisplayedSlides, function() {
      __p += '<div class="slide-control__slide needsclick" data-slide ';
      if (context.zoomEnabled) {
        __p += 'is="zoomable-element"';
      }
      __p += '></div>';
    })
    __p += '</div></div></div>';
    return __p;
  }
});